

  import { computed, ref } from 'vue'
  import moment from 'moment';
  import {FilterMatchMode, FilterOperator} from "primevue/api";
  import router from "@/router";
  import {useToast} from "primevue/usetoast";
  import {useStore} from "vuex";
  import {RegisterService} from "@/models/registerService";
  import ZaloRepository from "@/services/ZaloRepository";
  import {ListService} from "@/models/listService";
  import {useRouter} from "vue-router";
  import zaloRepository from "@/services/ZaloRepository";
  import VuePdfEmbed from 'vue-pdf-embed';
  import {HoSoDichVuCong} from "@/models/hoSoDichVuCong";
  import {HoSoDichVuCongDetail} from "@/models/hoSoDichVuCongDetail";
  import axios from "axios";
  import {LinhVuc} from "@/models/linhVuc";

  export default {
    components: {
      VuePdfEmbed,
    },
    setup() {
      const toast = useToast();
      const store = useStore();
      const date = ref();
      const service = ref("");
      const selectLinhVuc = ref("");
      const router = useRouter();
      const kind = ref(0);
      const listHSDVC = ref([] as HoSoDichVuCongDetail[]);
      const listHSDVCTemp = ref([] as HoSoDichVuCongDetail[]);
      const hsdvc = ref({} as HoSoDichVuCongDetail);
      const select = ref(0);
      const location = ref([
        // { label: 'Tài khoản cấp tổ', value: 'civilGroup' },
        // { label: 'Tài khoản cấp phường', value: 'ward' },
        { label: 'Trả hồ sơ tại phường', value: 1 },
        { label: 'Trả hồ sơ tại nhà', value: 2 },
      ]);
      const dsLinhVuc = ref([] as LinhVuc[]);

      const selectCalendar = () => {
        if((date.value[0] != null)&&(date.value[1] != null))
        {
          listHSDVCTemp.value = listHSDVC.value = [];
          zaloRepository.getListHSDVC(date.value[0]/1000, date.value[1]/1000)
              .then((response) => {
                listHSDVCTemp.value = listHSDVC.value = response.data;
                console.log("@@@@@@@@@################ list: " + JSON.stringify(listHSDVC.value));
                listHSDVCTemp.value.forEach(x => {
                  var checkLinhVuc = true
                  dsLinhVuc.value.forEach(y => {
                    if(y.name == x.linhVuc)
                    {
                      checkLinhVuc = false;
                    }
                  })
                  if(checkLinhVuc){
                    dsLinhVuc.value.push({name: x.linhVuc});
                  }
                })
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })})
        }
      };

      const selectKind = computed(()=> {
        if(select.value == 1){
          listHSDVC.value = listHSDVCTemp.value.filter(x => x.lePhi == x.tienThanhToan);
        }
        else if(select.value == 2)
        {
          listHSDVC.value = listHSDVCTemp.value.filter(x => x.lePhi != x.tienThanhToan);
        }
      });

      //selectCalendar();

      const clearCalendar = () => {
        listHSDVC.value = [];
      }

      const formatDateTime = (date) => {
        console.log("@@@@@@@@@################ formatDateTime date: " + date.value);
        if((date == null)||(date == ''))
        {
          return "chưa có thông tin"
        }
        else
        return moment(String(date)).format(' DD/MM/YYYY HH:mm:ss');
      };


      const validDate = (registerService: RegisterService) => {
        return registerService.timeConfirm;
      }

      const clearDate = () => {
        console.log("@@@@@@@@@################ clearDate");
        date.value = new Date();
      }

      const status = (id, xn) => {
        if(xn) return "Cho phép nghỉ";
        else {
          if(id > 0) return "Không cho phép nghỉ";
          else return "Chưa xác nhận";
        }
      }

      const formatCurrency = (money) => {
        // Use Intl.NumberFormat to format the number as currency
        const formatter = new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
          minimumFractionDigits: 0, // Set the number of decimal places you want
        });
        return formatter.format(money);
      };

      const checkKind = (lePhi, tienThanhToan) => {
        if(lePhi == tienThanhToan) return true;
        else return false;
      }

      const loadingBar = ref(false);
      const file = ref("");

      const downLoadFileExport = (file) => {
        axios({
          url: '../api/webhook/downloadFileExport/' + file,
          method: 'GET',
          responseType: 'blob',
        })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', "DanhSachHoSo" + ".xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      };


      const createExcelFileResult = () => {
        loadingBar.value = true;
        ZaloRepository.exportExcelHS(listHSDVC.value)
            .then((response) => {
              loadingBar.value = false;
              file.value = response.data;
              toast.add({
                severity: 'success',
                summary: 'Thành công',
                detail:'Xuất dữ liệu thành công',
                life: 2500
              });
            })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      }
      const viewBL = ref(false);
      const selectViewHD = (id) => {
        listHSDVC.value.forEach(x => {
          if(x.id == id){
            viewBL.value = true;
            hsdvc.value = x;
          }
        })
      }

      const printPDF = () => {
        // this.
      }

      const selectLV = () => {
        listHSDVC.value = listHSDVCTemp.value.filter(x => x.linhVuc == selectLinhVuc.value);
      }

      return {
        formatDateTime,
        listHSDVC,
        date,
        selectCalendar,
        clearCalendar,
        service,
        validDate,
        kind,
        clearDate,
        status,
        formatCurrency,
        checkKind,
        location,
        select,
        selectKind,
        downLoadFileExport,
        createExcelFileResult,
        file,
        loadingBar,
        selectViewHD,
        viewBL,
        hsdvc,
        printPDF,
        dsLinhVuc,
        selectLinhVuc,
        selectLV
      }
    }

  }
